import HospitalUserEdit from './HospitalUserEdit';

export default HospitalUserEdit;
